import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// Your web app's Firebase configuration  *in production
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
 
 apiKey: "AIzaSyAaM-9Yp6FCNTQWgoRy2OboPa8a3podPvs",
  authDomain: "okahandja-municipality-pms.firebaseapp.com",
  projectId: "okahandja-municipality-pms",
  storageBucket: "okahandja-municipality-pms.firebasestorage.app",
  messagingSenderId: "35628990074",
  appId: "1:35628990074:web:9933282ffe008a846085c3",
  measurementId: "G-H55XYY4029"

  // apiKey: "AIzaSyDasgXX3u3cLujb7rwGlJpqgXV2wwfmKS8",
  // authDomain: "nkurenkuru-town-council.firebaseapp.com",
  // projectId: "nkurenkuru-town-council",
  // storageBucket: "nkurenkuru-town-council.appspot.com",
  // messagingSenderId: "651659197779",
  // appId: "1:651659197779:web:122730299f6c30bbacf5a6",
  // measurementId: "G-N3BJ50MDSN"

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const appAuthWorker = initializeApp(firebaseConfig, "authWorker");

export const auth = getAuth(app);
export const authWorker = getAuth(appAuthWorker);

export const analytics = getAnalytics(app);
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

export const storage = getStorage(app);
export const functions = getFunctions(app);

